import { datadogRum } from '@datadog/browser-rum'

interface InitializerProps {
  id?: string
  name?: string
  email?: string
}

export function datadogInitializer({ id, name, email }: InitializerProps): void {
  const datadogConfig = {
    applicationId: 'da7adb4e-b5e4-4521-b990-7f8fc669d32f',
    clientToken: 'pub010a222f3cf13fa323412b09e8e39b06',
    site: 'datadoghq.com',
  }

  datadogRum.init({
    ...datadogConfig,
    service: 'voyage',
    env: 'production',
    version: 'e92b4488f5dabebe737c1059aa466d0215859c7f',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    silentMultipleInit: true,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: 'allow',
    allowedTracingUrls: [
      'https://arriere.prod.avantstay.com',
      'https://apollo-router.prod.avantstay.com',
      'https://hive-router.prod.avantstay.com',
    ],
  })

  if (id) {
    datadogRum.setUser({
      id,
      name,
      email,
    })
  }

  datadogRum.startSessionReplayRecording()
}
